import { cloneDeep } from "lodash";
//import sendxAPI from '../xAPI'

const initialState = {
  snapshots: {},
  attempts: 3
};

let tempSnaps;

export function UndoReducer(state = initialState, action){
  let protocolSection = state.protocolSection;

  switch (action.type) {
    case "SAVE_SNAPSHOT":
      //Payload = {snapshot}
      tempSnaps = {};

      let dragItems = document.getElementsByClassName('draggable');
      let transformData = [];

      for(var x = 0; x < dragItems.length; x++){
        transformData.push({
          id: dragItems[x].id,
          transform: dragItems[x].style.transform
        });
      }

      for(var i = 1; i <= (Object.keys(protocolSection.scene.undo.snapshots).length + 1); i++ ){
        //Move snapshots down 1 step and save latest as back1

        let scene = action.payload.snapshot.scene;
        delete scene.undo;

        if(i === 1){
          tempSnaps['back' + i] = {
            scene: scene,
            sequence: action.payload.snapshot.sequence,
            tableData: action.payload.snapshot.sequence,
            ...{transform: transformData}
          };
        } else if(i < 4) {
          tempSnaps['back' + i] = cloneDeep(protocolSection.scene.undo.snapshots['back' + (i - 1)]);
        }
      }

      protocolSection.scene.undo.snapshots = tempSnaps;

      return { ...state, ...{
        protocolSection: protocolSection
      } }

    case "UNDO":
      //Payload = {lastState}
      //But don't need the payload here, only in other reducers

      if (protocolSection.scene.undo.attempts > 0 && Object.keys(protocolSection.scene.undo.snapshots).length > 0) {
        let tempSnaps2 = {};

        for(var y = 0; y < action.payload.lastState.transform.length; y++){
          //console.log(action.payload.lastState.transform[i].id)
          if(action.payload.lastState.transform[y].id !== ""){
            let elem = document.getElementById(action.payload.lastState.transform[y].id);

            if(elem !== null){
              elem.style.transform = action.payload.lastState.transform[y].transform;
            }
          }
        }

        for(var z = 1; z < (Object.keys(protocolSection.scene.undo.snapshots).length); z++ ){
          //Move snapshots down 1 step and save latest as back1
          tempSnaps2['back' + z] = cloneDeep(protocolSection.scene.undo.snapshots['back' + (z + 1)]);
        }

        protocolSection.scene.undo.snapshots = tempSnaps2;
        protocolSection.scene.undo.attempts = protocolSection.scene.undo.attempts - 1;

        return { ...state, ...{
          protocolSection: protocolSection
        } }

        // xAPI statement
        // sendxAPI({
        //   // Type of statement
        //   verb: {
        //     description: "reset",
        //     address: "https://w3id.org/xapi/dod-isd/verbs/reset"
        //   },
        //   // Where the action occured
        //   context: "Protocol task: " + state.snapshots.back1.notebook.focusedTaskObj.levels["l"+state.snapshots.back1.notebook.level].task,
        //   // Result of the action
        //   result: {
        //     success: true,
        //     response: state.attempts + " attempts left"
        //   }
        // })

      } else {
        return state;
      }

    case "SET_UNDO_ATTEMPTS":
      //Payload = {attempts}
      protocolSection.scene.undo.attempts = action.payload.attempts;

      return { ...state, ...{
        protocolSection: protocolSection
      } }

    default:
      return state;
  }
};
